// src/components/AuthGuard/index.js - 修复版
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './index.css';

function AuthGuard({ children, requireAuth = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 显示加载状态
  if (loading) {
    return (
      <div className="auth-loading">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        <p>验证中...</p>
      </div>
    );
  }

  // 需要登录但未登录
  if (requireAuth && !user) {
    // 保存原始访问路径，以便登录后重定向回来
    const redirectPath = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth?redirect=${redirectPath}`} replace />;
  }

  // 不需要登录但已登录，且访问的是登录/注册页，重定向到首页
  if (!requireAuth && user && location.pathname === '/auth') {
    const redirect = new URLSearchParams(location.search).get('redirect');
    return <Navigate to={redirect || '/'} replace />;
  }

  // 有权限，渲染子组件
  return children;
}

export default AuthGuard;